import dayjs from 'dayjs';

export const getIntervalFromDateRange = (
  startDate: string,
  endDate: string,
): 'hourly' | 'daily' | 'weekly' | 'monthly' => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const now = dayjs();

  const diffInDays = end.diff(start, 'day');

  if (diffInDays === 0) return 'hourly';
  if (diffInDays < 7) return 'daily';

  const isEndInCurrentMonth = end.isSame(now, 'month');
  const hasMonthEnded = now.isSame(now.endOf('month'), 'day');
  const daysIntoCurrentMonth = now.diff(now.startOf('month'), 'day') + 1;

  if (isEndInCurrentMonth && !hasMonthEnded) {
    if (daysIntoCurrentMonth < 7) {
      return 'daily';
    }

    return 'weekly';
  }

  if (diffInDays >= 30) {
    return 'monthly';
  }

  return 'weekly';
};

export const getRandomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
